import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`Set`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Range`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Notes`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><abbr title="International Phonetic Alphabet">{`IPA`}</abbr>{` Extensions`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0250-02AF`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}>{`1 char`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Spacing Modifier Letters`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+02B0-02FF`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}>{`19 chars`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Combing Diacritical Marks`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0300-036F`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}>{`25 chars`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Greek`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0370-03FF`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}>{`3 chars`}</td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      